export default __webpack_public_path__ + "2a878e9.png";